"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Do not edit this file, it is automatically generated by @paprika/build-translations
var locales = {
    "es": {
        "translation": {
            "global_navigation": {
                "navigation_items": {
                    "logo": "Volver a Launchpad",
                    "app_switcher": "Cambiar aplicaciones",
                    "announcer": "Anuncios",
                    "helper": "Ayuda y soporte",
                    "user": "Inició sesión: {{username}}",
                    "user_with_customer": "{{username}} {{customerName}}",
                    "sign_in": "Iniciar sesión"
                },
                "apps": {
                    "academy": "Academia",
                    "community": "Comunidad",
                    "projects": "Proyectos",
                    "results": "Resultados",
                    "storyboards": "Storyboards",
                    "mission_control": "Control de la misión",
                    "risks": "Estrategia",
                    "reports": "Reportes",
                    "launchpad": "Launchpad",
                    "robots": "Robots",
                    "frameworks": "Marcos",
                    "compliance_maps": "Mapas de cumplimiento",
                    "assurance_plans": "Planes de aseguramiento",
                    "project_scheduler": "Programador",
                    "issue_tracker": "Rastreador de asuntos",
                    "task_tracker": "Rastreador de tareas",
                    "project_timesheets": "Planillas de horas",
                    "dashboard": "Tablero de mando de {{module}}",
                    "master_library": "Biblioteca maestra"
                },
                "app_sections": {
                    "setup": "Configuración",
                    "workspace": "Área de trabajo",
                    "automation": "Automatización"
                },
                "user": {
                    "my_profile": "Mi perfil",
                    "log_out": "Finalizar la sesión"
                },
                "helper": {
                    "help_docs": "Documentos de ayuda",
                    "support": "Soporte"
                },
                "skip_button": "Ir al contenido principal",
                "logo": "logotipo",
                "other": "Otro",
                "section": "sección"
            }
        }
    }
};
exports.default = locales;
//# sourceMappingURL=es.js.map